import { ReactNode } from 'react';
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import { cn } from '../../lib/cn';

type AlertTone = 'error' | 'success' | 'warning' | 'info';

const TONE_CLASS: Record<AlertTone, string> = {
  error: 'border-bad/30 bg-bad-light text-bad',
  success: 'border-ok/30 bg-ok-light text-ok',
  warning: 'border-warn/30 bg-warn-light text-warn',
  info: 'border-primary/20 bg-primary-light text-primary-dark',
};

const TONE_ICON = { error: CircleAlert, success: CircleCheck, warning: TriangleAlert, info: Info };

export interface AlertProps {
  tone?: AlertTone;
  children: ReactNode;
  className?: string;
}

/** Inline message box — every API `{error}` string is shown through one of these. */
export function Alert({ tone = 'error', children, className }: AlertProps) {
  const Icon = TONE_ICON[tone];
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={cn('flex items-start gap-2 rounded-xl border px-3 py-2.5 text-sm', TONE_CLASS[tone], className)}>
      <Icon size={16} className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1 break-words font-medium">{children}</div>
    </div>
  );
}
